var WPQTTypes;
(function (WPQTTypes) {
    WPQTTypes["Task"] = "task";
    WPQTTypes["User"] = "user";
})(WPQTTypes || (WPQTTypes = {}));
var WPQTLogCreatedBy;
(function (WPQTLogCreatedBy) {
    WPQTLogCreatedBy["System"] = "system";
    WPQTLogCreatedBy["Admin"] = "admin";
    WPQTLogCreatedBy["WPQTUser"] = "quicktasker_user";
})(WPQTLogCreatedBy || (WPQTLogCreatedBy = {}));
var WPQTArchiveDoneFilter;
(function (WPQTArchiveDoneFilter) {
    WPQTArchiveDoneFilter["All"] = "all";
    WPQTArchiveDoneFilter["Completed"] = "completed";
    WPQTArchiveDoneFilter["NotCompleted"] = "not completed";
})(WPQTArchiveDoneFilter || (WPQTArchiveDoneFilter = {}));
export { WPQTArchiveDoneFilter, WPQTLogCreatedBy, WPQTTypes };
